/** Fixed UDO templates owned by Event Containers. */
export enum OttopilotEventContainersWorkspaceCapabilityUdoTemplateKey {
    roundRobinCursor = "ddcbdda1-fd00-43e7-a181-e1d91b22ba5f",
}
